import { Phone } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import ProfilePicture from "@govlaunch/profile-picture";
import { Anchor } from "@govlaunch/web";
import Link from "next/link";
import { IGetGovernmentQuery } from "../../lib/queries/__generated__/GetGovernmentQuery.generated";
import Container from "../layout/Container";

interface IMenuProps {
  government: NonNullable<IGetGovernmentQuery["government"]>;
}

export default function Menu({ government }: IMenuProps) {
  return (
    <Phone>
      {(isPhone: boolean) => (
        <div
          css={{
            backgroundColor: "white",
            borderBottom: `1px solid ${palette.lightestGray}`
          }}
        >
          <Container>
            <div
              css={{
                display: "flex",
                justifyContent: isPhone ? "center" : "space-between",
                alignItems: "center",
                padding: "24px 0"
              }}
            >
              <div
                css={{
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <Link as="/" href="/">

                  <ProfilePicture
                    size={isPhone ? 70 : 90}
                    name={government.name}
                    image={government.logo}
                    css={{
                      boxShadow: "0 2px 5px 0 #00000033"
                    }}
                  />

                </Link>

                <div
                  css={{
                    marginLeft: 16
                  }}
                >
                  <Link as="/" href="/" css={{
                    textDecoration: "none"
                  }}>

                    <h1
                      css={{
                        color: palette.text,
                        fontSize: isPhone ? 22 : 28,
                        fontWeight: "bold",
                        margin: 0
                      }}
                    >
                      {government.name}
                    </h1>

                  </Link>

                  {government.site && (
                    <Anchor
                      href={government.site}
                      external="outside-govlaunch"
                      css={{
                        display: "inline-block",
                        fontSize: 14,
                        color: palette.sealBlue,
                        textDecoration: "none",
                        "&:focus, &:visited": {
                          color: palette.darkGray
                        },

                        "&:hover": {
                          color: palette.darkGray,
                          borderBottom: `solid 1px ${palette.sealBlue}`
                        }
                      }}
                    >
                      {getHostname(government.site)}
                    </Anchor>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </div>
      )}
    </Phone>
  );
}

function getHostname(url: string) {
  if (!url) {
    return "";
  }

  try {
    const parsed = new URL(url);
    return parsed.hostname;
  } catch {
    return "";
  }
}
